import React from 'react'
import { Link } from 'react-router-dom'
import { useCart } from '../Context/CartContext'
import { useCurrency } from '../Context/CurrencyContext'
import WishlistButton from './WishlistButton'
import './ProductCard.css'

export function formatRf(rwf) {
    return `${Math.round(Number(rwf) || 0).toLocaleString('en-US')} RF`
}

export function formatUsdApprox(rwf, rates) {
    const rate = rates?.USD || 0.00072
    return `≈ $${Math.max(1, Math.round((Number(rwf) || 0) * rate))}`
}

/**
 * Compact catalogue card (shop and collection pages): large image, one-line title, price,
 * then Add to Cart beside a square wishlist button. Optional quick view on hover.
 * Products without stock data count as available.
 */
function ProductCard({ product, addedProduct, onAdded, onQuickView }) {
    const { addToCart } = useCart()
    const { formatPrice } = useCurrency()
    const oldPrice = product.priceOld || null
    const onSale = oldPrice && oldPrice > product.price
    const discountValue = onSale ? Math.round(((oldPrice - product.price) / oldPrice) * 100) : null
    const inStock = product.stock == null || Number(product.stock) > 0
    const added = addedProduct === product.id
    const detailsPath = `/product-details/${product.id}`

    return (
        <article className="col-card">
            <div className="col-card__media">
                <Link className="col-card__media-link" to={detailsPath} state={{ product }} aria-label={product.name}>
                    <img
                        src={product.image}
                        alt=""
                        loading="lazy"
                        onError={(e) => {
                            e.currentTarget.src = '/placeholder-image.png'
                        }}
                    />
                </Link>
                {onSale && <span className="col-card__sale">-{discountValue}%</span>}
                {onQuickView && (
                    <button type="button" className="col-card__quick" onClick={() => onQuickView(product)}>
                        <i className="fa-regular fa-eye" aria-hidden="true" />
                        Quick view
                    </button>
                )}
            </div>

            <div className="col-card__body">
                <Link className="col-card__title" to={detailsPath} state={{ product }} title={product.name}>
                    {product.name}
                </Link>
                <div className="col-card__price">
                    <strong>{formatPrice(product.price)}</strong>
                    {onSale && <s>{formatPrice(oldPrice)}</s>}
                </div>
                <div className="col-card__actions">
                    <button
                        type="button"
                        className={`col-card__cta${added ? ' is-added' : ''}`}
                        disabled={!inStock}
                        onClick={() => {
                            if (!inStock) return
                            addToCart(
                                {
                                    id: product.id,
                                    name: product.name,
                                    title: product.title || product.name,
                                    price: product.price,
                                    image: product.image,
                                    category: product.category,
                                },
                                1
                            )
                            onAdded?.(product)
                        }}
                    >
                        {added ? (
                            <>
                                <i className="fa-solid fa-check" aria-hidden="true" />
                                Added
                            </>
                        ) : inStock ? (
                            'Add to Cart'
                        ) : (
                            'Out of stock'
                        )}
                    </button>
                    <WishlistButton product={product} className="col-card__wish" />
                </div>
            </div>
        </article>
    )
}

export default ProductCard
